import enLang from './entries/en-US';
import esLang from './entries/es-ES';
import prLang from './entries/pr-BR';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AppLocale: Record<string, any> = {
  en: enLang,
  es: esLang,
  pr: prLang,
};

export default AppLocale;
